var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['nav__a', { 'active': _vm.isActive }],attrs:{"href":_vm.link.url,"title":("Go to page: " + (_vm.link.title))}},[_vm._v("\n  "+_vm._s(_vm.link.title)+"  \n")])}
var staticRenderFns = []

export { render, staticRenderFns }